<pt-feature-info />
<pt-breadcrumbs class="bg-white" [breadcrumbs]="breadcrumbs$ | async" />
<div class="border-b border-solid border-slate-300"></div>
<mat-progress-bar *ngIf="loading$ | async" mode="indeterminate" />

<div class="wrapper flex flex-col gap-4">
  <div class="flex items-center justify-between" Ø>
    <div class="flex items-center gap-2">
      <h1 class="mat-headline-4 !mb-0">{{ snippetsLabel$ | async }}</h1>
      <div
        class="subheader-row"
        fxLayout="row"
        fxLayoutAlign="space-between center"
      >
        <button
          mat-icon-button
          matTooltip="Show / Hide Deleted"
          (click)="toggleDeleted()"
        >
          <mat-icon *ngIf="showDeleted$ | async; else deletedHidden"
            >visibility_off</mat-icon
          >
          <ng-template #deletedHidden>
            <mat-icon>visibility</mat-icon>
          </ng-template>
        </button>
      </div>
    </div>

    <button mat-flat-button color="primary" (click)="openSnippetForm()">
      Create Snippet
    </button>
  </div>

  <pr-content-container
    class="snippet-container mat-elevation-z1 flex bg-white"
  >
    <mat-nav-list class="snippet-nav flex w-1/4 flex-col !pr-4 !pt-0">
      <ng-container *ngIf="snippets$ | async as snippets">
        <ng-container *ngIf="snippets.length; else addSnippet">
          <ng-container
            *ngFor="let snippet of snippets; trackBy: trackBySnippet"
          >
            <a
              *ngIf="!snippet.deleted || (showDeleted$ | async)"
              mat-list-item
              ptIntercomTarget="snippet.link"
              [ngClass]="{
                deleted: snippet.deleted
              }"
              [activated]="activeSnippet === snippet"
              [routerLink]="['./', snippet.ref.id]"
              (click)="activeSnippet = snippet"
            >
              {{ snippet.name }}
            </a>
          </ng-container>
        </ng-container>
      </ng-container>

      <ng-template #addSnippet>
        <mat-list-item>
          <mat-icon matListItemIcon>add</mat-icon>
          <a matListItemTitle (click)="openSnippetForm()">Add a Snippet</a>
        </mat-list-item>
      </ng-template>
    </mat-nav-list>

    <mat-divider [vertical]="true" />

    <div class="snippet-body layout-padding" fxFlex>
      <router-outlet />
    </div>
  </pr-content-container>
</div>
